import React, { useMemo } from 'react'
import { Button } from 'antd'

export function WikiLinkButton({ moduleName, project }: { moduleName: string, project: { wikiUrlDelivery: string, wikiUrlWaste: string } }) {
  const address = useMemo(() => {
    if (moduleName.toLowerCase() === 'delivery') {
      return project.wikiUrlDelivery
    } else if (moduleName.toLowerCase() === 'waste') {
      return project.wikiUrlWaste
    }
    console.error(`WikiLinkButton: Unsupported moduleName: ${moduleName}`);
    return null;
  }, [moduleName, project.wikiUrlDelivery, project.wikiUrlWaste]);

  if (!address) {
    return null
  }

  return (
    <Button
      type="link"
      rel="noopener noreferrer nofollow"
      href={address}
      target="_blank"
    >
      Wiki
    </Button>
  )
}
